interface DepartureRowClickParams {
  /** The whole section is disabled (e.g. edit mode while saving). */
  disabled: boolean
  /** The sail can't take the tickets: the reservation's in edit mode, one passenger on purchase. */
  insufficientCapacity: boolean
  isCancelled: boolean
  isClosed: boolean
  onSelect: () => void
  /** Explains why the sail can't be picked (edit mode toast). Without it such a row is disabled. */
  onInsufficientCapacityClick?: () => void
}

// A cancelled or closed sail can't be clicked. A sail without enough capacity can't be picked either:
// it stays clickable only to explain why (edit mode shows a toast), otherwise it is disabled too.
export const getDepartureRowClick = ({
  isCancelled,
  isClosed,
  disabled,
  insufficientCapacity,
  onSelect,
  onInsufficientCapacityClick,
}: DepartureRowClickParams) => {
  const isDisabled = isCancelled || isClosed || disabled || (insufficientCapacity && !onInsufficientCapacityClick)

  const handleClick = () => {
    if (isDisabled) return
    if (insufficientCapacity) {
      onInsufficientCapacityClick?.()
      return
    }
    onSelect()
  }

  return { isDisabled, handleClick }
}
